import { apiGet, apiPost } from './client';

export function listReplies(status) {
  return apiGet(`/replies/list${status ? `?status=${status}` : ''}`);
}

export function getReply(replyId) {
  return apiGet(`/replies/detail?replyId=${replyId}`);
}

export function updateReplyDraft(replyId, updates) {
  return apiPost('/replies/update', { replyId, ...updates });
}

export function sendReplyEmail(replyId) {
  return apiPost('/replies/send', { replyId });
}

export function dismissReply(replyId) {
  return apiPost('/replies/dismiss', { replyId });
}

export function testIngestReply(data) {
  return apiPost('/replies/test-ingest', data);
}

export function getPendingCount() {
  return apiGet('/replies/pending-count');
}
